<template>
  <custom-dialog :visible="visible" width="680px" class="project-site-dialog" :title="model.title" v-on="$listeners" appendToBody>
    <div class="dialog-body">
      <div class="msg-content">
        <ul class="msg-list">
          <li>
            <div class="key">{{ $t('dms_project_floor_dialog.xiang_mu_ming_cheng') }}</div>
            <div class="val">{{ locationInfo.locationName }}</div>
          </li>
        </ul>
      </div>
      <div class="input-container">
        <el-form ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col>
              <el-form-item :label="$t('dms_project_floor_dialog.qybqmc')" prop="floorName">
                <el-input v-model="form.floorName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col>
              <el-form-item :label="$t('page_project_qu_yu_mian_ji')" prop="contactName">
                <el-input v-model="form.contactName"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col>
              <el-form-item :label="$t('page_project_qyqxsct')" prop="contactPhone">
                <el-input v-model="form.contactPhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        floorId: '', // 区域标签Id
        floorName: '', // 区域标签名称
        locationId: '', // 项目Id
      },
      locationInfo: {},
    };
  },
  mounted: function () {
    this.initForm();
  },

  computed: {
    rules() {
      return {
        floorName: [
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
  },
  methods: {
    initForm() {
      if (this.model.type === 'add' && this.model.data.type !== '3') {
        this.form.locationId = this.model.data.locationId; // 项目Id
        this.getProjectInfo();
      } else if (this.model.type === 'add' && this.model.data.type === '3') {
        // 区域里面的新增
        this.form.floorId = this.model.data.floorId; // 项目Id
        this.getFloorAdd();
      } else {
        this.form.locationId = this.model.data.locationId; // 项目Id
        this.getProjectInfo();
        this.form.floorId = this.model.data.floorId; // 项目Id
        this.getFloorInfo();
      }
    },
    getProjectInfo() {
      this.$getJSON(apis.locationInfo, { locationId: this.form.locationId }).then((res) => {
        const data = res.data || {};
        this.locationInfo = data;
      });
    },
    getFloorInfo() {
      this.$getJSON(apis.locationFloorInfo, { floorId: this.form.floorId }).then((res) => {
        const data = res.data || {};
        // this.floorInfo = data;
        this.$setFormatData(this.form, data);
      });
    },
    getFloorAdd() {
      this.$getJSON(apis.locationFloorInfo, { floorId: this.form.floorId }).then((res) => {
        const data = res.data || {};
        // this.floorInfo = data;
        this.form.locationId = data.locationId;
        this.getProjectInfo();
      });
    },
    updateFloorList() {
      this.$refs.floor.getSelectList();
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      if (this.model.type === 'add') {
        this.add();
      } else {
        this.edit();
      }
    },
    edit() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.locationFloorUpdate, this.form, true).then(() => {
            this.$emit('success');
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
          });
        }
      });
    },
    add() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.locationFloorAdd, this.form, true).then(() => {
            this.$emit('success');
            this.closeDialog();
            this.$message({
              type: 'success',
              message: this.$t('Common.com_add_success'),
            });
          });
        }
      });
    },
    addFloor() {},
  },
};
</script>

<style lang="scss">
.project-site-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    width: 100%;
    padding: 0 !important;
    display: flex;
    .msg-content {
      width: 260px;
      padding: 0 24px 40px;
      // height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
  }
}
</style>
